import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { useToastContext } from '@/layout/context/toast-context';
import { applySupervisorForceService } from '@/shared/auth/auth.reducer';
import { useBreakUserTopicSubscription } from '@/shared/hooks/useBreakUserTopicSubscription';
import { describeClearedPauseTypes, resolveForceServiceClearedTypes, } from '@/shared/model/break-event.model';
import { useAppDispatch, useAppSelector } from '@/store';
/**
 * Listens for supervisor force-return events on `/topic/break.user.{username}`
 * and clears break / ACW / incoming-pause UI state from `clearedPauseTypes`.
 */
export function BreakEventsProvider({ children }) {
    const dispatch = useAppDispatch();
    const { showToast } = useToastContext();
    const session = useAppSelector((state) => state.auth.session);
    const username = session?.username?.trim() ?? '';
    const onBreakEnded = useCallback((event) => {
        const clearedPauseTypes = resolveForceServiceClearedTypes(event);
        dispatch(applySupervisorForceService({ clearedPauseTypes }));
        const by = event.endedBy?.trim();
        const clearedLabel = describeClearedPauseTypes(clearedPauseTypes);
        showToast({
            severity: 'info',
            summary: 'Returned to service',
            detail: by
                ? `Supervisor ${by} cleared your ${clearedLabel}. You are available for calls again.`
                : `A supervisor cleared your ${clearedLabel}. You are available for calls again.`,
            life: 6000,
        });
    }, [dispatch, showToast]);
    useBreakUserTopicSubscription({
        username,
        enabled: Boolean(username),
        onBreakEnded,
    });
    return _jsx(_Fragment, { children: children });
}
